import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { API } from '@/App';
import { Button } from '@/components/ui/button';

const STATE = {
  different: ['Différent du serveur', 'bg-red-100 text-red-800'],
  postes_divergents: ['Postes en désaccord', 'bg-red-100 text-red-800'],
  absent_serveur: ['Absent du serveur', 'bg-amber-100 text-amber-800'],
  sans_journee: ['Aucune journée ce jour', 'bg-slate-100 text-slate-700'],
  identique: ['Identique', 'bg-emerald-100 text-emerald-800'],
};
const err = (e) => (typeof e?.response?.data?.detail === 'string' ? e.response.data.detail : 'Erreur réseau');
const fmtH = (v) => (v === null || v === undefined ? '—' : `${v} h`);

const Cell = ({ cell, onApply, onKeep }) => {
  const [label, cls] = STATE[cell.state] || [cell.state, ''];
  return (
    <div className="rounded border bg-white p-3 text-sm" data-testid={`legacy-cell-${cell.user_id}-${cell.date}`}>
      <div className="flex flex-wrap items-center gap-2">
        <span className="font-medium">{cell.user_name || cell.user_id} — {new Date(`${cell.date}T12:00:00`).toLocaleDateString('fr-FR')}</span>
        <span className={`rounded px-2 py-0.5 text-xs font-semibold ${cls}`}>{label}</span>
        <span className="ml-auto">Serveur : <b>{fmtH(cell.server_manual_hours)}</b></span>
      </div>
      <div className="mt-2 space-y-1">
        {cell.versions.map((v) => (
          <div key={v.id} className="flex flex-wrap items-center gap-2 text-xs">
            <span>Poste {v.device_id} ({v.admin_name || 'admin'}, transmis le {new Date(v.uploaded_at).toLocaleString('fr-FR')}) : <b>{fmtH(v.hours)}</b></span>
            {cell.schedule_id && cell.state !== 'identique' && (
              <Button size="sm" variant="outline" onClick={() => onApply(cell, v)} data-testid={`legacy-apply-${v.id}`}>Appliquer cette valeur</Button>
            )}
          </div>
        ))}
      </div>
      <Button size="sm" variant="ghost" className="mt-1" onClick={() => onKeep(cell)} data-testid={`legacy-keep-${cell.user_id}-${cell.date}`}>
        {cell.state === 'identique' ? 'Marquer comme traité' : 'Garder la valeur serveur'}
      </Button>
    </div>
  );
};

export const LegacyHoursReview = () => {
  const [cells, setCells] = useState(null);
  const load = useCallback(() => {
    axios.get(`${API}/schedule/integrity/legacy-manual-hours`).then((r) => setCells(r.data.cells)).catch((e) => toast.error(err(e)));
  }, []);
  useEffect(() => { load(); }, [load]);
  const apply = async (cell, v) => {
    if (!window.confirm(`Remplacer ${fmtH(cell.server_manual_hours)} par ${fmtH(v.hours)} ? L'ancienne valeur est conservée dans l'historique de la journée.`)) return;
    try {
      await axios.post(`${API}/schedule/integrity/legacy-manual-hours/apply`, { version_id: v.id, expected_server_manual_hours: cell.server_manual_hours });
      toast.success('Valeur appliquée'); load();
    } catch (e) { toast.error(err(e)); load(); }
  };
  const keep = async (cell) => {
    try {
      await axios.post(`${API}/schedule/integrity/legacy-manual-hours/keep-server`, { user_id: cell.user_id, date: cell.date });
      toast.success('Valeur serveur conservée'); load();
    } catch (e) { toast.error(err(e)); }
  };
  return (
    <section data-testid="legacy-hours-section">
      <h2 className="mb-1 text-lg font-semibold">Anciennes heures « Calcul salaire » des postes ({cells ? cells.length : '…'})</h2>
      <p className="mb-2 text-sm text-slate-600">Heures saisies autrefois dans le navigateur de chaque ordinateur, transmises automatiquement à l’ouverture du site par un admin. Rien n’est appliqué sans votre choix.</p>
      {cells?.length === 0 && <p className="text-sm text-emerald-700" data-testid="legacy-hours-empty">Aucune heure locale à rapprocher pour l’instant.</p>}
      <div className="space-y-2">{(cells || []).map((c) => <Cell key={`${c.user_id}|${c.date}`} cell={c} onApply={apply} onKeep={keep} />)}</div>
    </section>
  );
};
